import { DateTime } from "luxon";

export const formatShipmentRangeDate = ({
  startDate,
  endDate,
}: {
  startDate: string | undefined;
  endDate: string | undefined;
}) => {
  const start = startDate ? DateTime.fromISO(startDate) : undefined;
  const end = endDate ? DateTime.fromISO(endDate) : undefined;

  if (start?.isValid && end?.isValid) {
    return `${start.toFormat("MMM dd, yyyy")} - ${end.toFormat("MMM dd, yyyy")}`;
  }

  return null;
};
